// src/contexts/ThemeContext.js
// ColorModeContext is consumed by Dashboard.js for the dark/light mode toggle.
// The actual theme provider lives in App.js — this file only exports the context.
import { createContext } from 'react';

export const ColorModeContext = createContext({ toggleColorMode: () => { } });
